// 全局挂载
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.config.globalProperties.window = window
})
